import { createSlice } from "@reduxjs/toolkit"

const initialState: { allBadges: Metricate.Badge[] } = {
  allBadges: [],
}

const badgeSlice = createSlice({
  name: "badge",
  initialState,
  reducers: {
    setAllBadges: (state, action) => {
      state.allBadges = action.payload
    },
  },
})

export const { setAllBadges } = badgeSlice.actions
export default badgeSlice.reducer
